import { defineComponent as _defineComponent } from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCircleExclamation, faSkullCrossbones } from '@fortawesome/pro-solid-svg-icons';
import { computed } from 'vue';

import i18n from '@/initI18n';

import { ThemeColors } from '@/shared/constants';


export default /*#__PURE__*/_defineComponent({
  __name: 'RiskPill',
  props: {
    riskCategory: null
  },
  emits: ["onClick"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'onClick'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  riskCategory: string;
}

library.add(faSkullCrossbones, faCircleExclamation);

const t = i18n.translate;





const riskCategoryText = computed(() =>
  props.riskCategory === 'high' ? t('High') : props.riskCategory === 'medium' ? t('Medium') : t('Low'),
);

const riskIcon = computed(() => (props.riskCategory === 'high' ? faSkullCrossbones : faCircleExclamation));

const backgroundColor = computed(() => {
  switch (props.riskCategory) {
    case 'high':
      return ThemeColors.DANGER;
    case 'medium':
      return ThemeColors.WARNING;
    case 'low':
      return ThemeColors.PRIMARY;
    default:
      return ThemeColors.PRIMARY;
  }
});

return { __sfc: true,t, props, emit, riskCategoryText, riskIcon, backgroundColor }
}

})